import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import api from "@/lib/api";
import { CourseCard } from "@/components/CourseCard";
import { Button } from "@/components/ui/button";

export default function CountryDetail() {
  const { slug } = useParams();
  const [country, setCountry] = useState(null);
  const [result, setResult] = useState(null);

  useEffect(() => {
    window.scrollTo(0, 0);
    api.get(`/public/countries/${slug}`).then((r) => {
      setCountry(r.data);
      api.get("/public/search", { params: { country_id: r.data.id, per_page: 24 } })
        .then((s) => setResult(s.data)).catch(() => {});
    }).catch(() => setCountry(false));
  }, [slug]);

  if (country === false) return (
    <div className="mx-auto max-w-2xl px-4 py-24 text-center">
      <h1 className="font-heading text-2xl font-bold text-slate-900">Country not found</h1>
      <Button asChild className="mt-6 bg-blue-800 hover:bg-blue-900"><Link to="/countries">All countries</Link></Button>
    </div>
  );

  return (
    <div className="bg-slate-50">
      <div className="mx-auto max-w-6xl px-4 py-10 md:px-6">
        <h1 className="font-heading text-3xl font-bold tracking-tight text-slate-900">
          Online Courses in {country?.name || "..."}
        </h1>
        {country?.description && <p className="mt-2 max-w-2xl text-slate-500">{country.description}</p>}
        {result && <p className="mt-2 text-sm text-slate-500">{result.university_count} universities · {result.total} programmes</p>}

        <div className="mt-8 space-y-4">
          {result?.results?.length ? result.results.map((c) => <CourseCard key={c.id} course={c} />)
            : <p className="rounded-xl border border-dashed border-slate-300 bg-white p-8 text-center text-slate-500">No programmes listed yet.</p>}
        </div>
      </div>
    </div>
  );
}
